import {field} from '../field'
import {mergeConfig} from '../../configStore'
import type {EmailField, FieldReturn} from '../../types'

export const email = (props?: EmailField, mergeProps?: Partial<EmailField>): FieldReturn =>
  field('email', mergeConfig('email', props, mergeProps))
